import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { UriApi } from '../helpers/UriApi';
declare const window: any;
@Injectable({ providedIn: 'root' })
export class UsersService {
    constructor(private http: HttpClient, private router: Router) { }

    body = {
        request: {
            userId: 20,
            userName: 'admin',
            jsonParams: '',
            functionCode: 100,
            option: 1,
            commandType: 1,
            data: null,
            dataList: [],
        }
    };


    checkUserNameExists(UserId: string) {
        return this.http.get(UriApi.api_validUsername, { params: { UserName: UserId } });
    }

    checkTelNoExists(telNo: string, userId: string) {
        return this.http.get(UriApi.api_validTelNo, { params: { PhoneNumber: telNo, UserId: userId } });
    }
}